import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { PAGE } from '../../theme';

/**
 * Largura padrão de qualquer página interna (admin e área do cliente).
 *
 * Existe para que nenhuma tela invente a própria largura: o valor vive em
 * `PAGE.maxWidth` (`theme.js`) e este contêiner só o aplica. Ele **não** traz
 * padding — o respiro lateral/vertical continua nos layouts (`Layout` e
 * `UserLayoutBrand`), então usar `PageContainer` dentro do layout não duplica
 * espaçamento.
 *
 * `data-testid` fixo: é o gancho dos testes (unitário e Playwright CT) que
 * garantem que todas as páginas partilham da mesma largura. `testId` existe só
 * para variações da mesma caixa (o skeleton do dashboard), e é aplicado depois
 * do `...rest` para que um `data-testid` solto não quebre o contrato.
 */
const PageContainer = ({ children, sx, testId = 'page-container', ...rest }) => (
  <Box
    sx={{
      width: '100%',
      maxWidth: PAGE.maxWidth,
      mx: 'auto',
      minWidth: 0,
      boxSizing: 'border-box',
      ...sx,
    }}
    {...rest}
    data-testid={testId}
  >
    {children}
  </Box>
);

PageContainer.propTypes = {
  children: PropTypes.node,
  /** Ajustes locais (ex.: `pb`). Não devem reintroduzir um `maxWidth` próprio. */
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.func]),
  /** Identificador de teste; o padrão é o usado pelas páginas. */
  testId: PropTypes.string,
};

export default PageContainer;
